/**
 * @generated SignedSource<<cb486a1125826d2159b1eafcb6eab21d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type JobTypeFields_Query$variables = Record<PropertyKey, never>;
export type JobTypeFields_Query$data = {
  readonly industries: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly name: string;
        readonly rawId: number | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type JobTypeFields_Query = {
  response: JobTypeFields_Query$data;
  variables: JobTypeFields_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 100
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rawId",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "JobTypeFields_Query",
    "selections": [
      {
        "alias": null,
        "args": (v0/*: any*/),
        "concreteType": "IndustryConnection",
        "kind": "LinkedField",
        "name": "industries",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "IndustryEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Industry",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": "industries(first:100)"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "JobTypeFields_Query",
    "selections": [
      {
        "alias": null,
        "args": (v0/*: any*/),
        "concreteType": "IndustryConnection",
        "kind": "LinkedField",
        "name": "industries",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "IndustryEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Industry",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": "industries(first:100)"
      }
    ]
  },
  "params": {
    "cacheID": "b3655d175353d95da67c37430131eeee",
    "id": null,
    "metadata": {},
    "name": "JobTypeFields_Query",
    "operationKind": "query",
    "text": "query JobTypeFields_Query {\n  industries(first: 100) {\n    edges {\n      node {\n        rawId\n        name\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "67663dbbcc5f93096b890aa975052594";

export default node;
